import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { ChevronDown, ArrowLeft, HelpCircle } from "lucide-react";
import { faqs } from "../data/faqs";

export default function FaqPage() {
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState({});

  const toggle = (key) => {
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="flex min-h-screen flex-col bg-[var(--c-bg)]">
      <Navbar />
      <div className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6 sm:py-12">
        {/* Back */}
        <button
          data-testid="back-from-faq"
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center gap-2 text-sm font-semibold text-[var(--c-muted)] hover:text-[var(--c-text)]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>

        {/* Hero */}
        <div className="mb-10 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl border-2 border-[var(--c-border)] bg-[#1E3A8A] shadow-[3px_3px_0px_var(--c-shadow)]">
            <HelpCircle className="h-7 w-7 text-white" />
          </div>
          <h1 className="font-heading text-3xl font-black tracking-tight text-[var(--c-text)] sm:text-4xl">
            Frequently Asked Questions
          </h1>
          <p className="mx-auto mt-3 max-w-lg text-base text-[var(--c-muted)]">
            Common questions about forming and running a Texas LLC. Can&apos;t find your answer? Use the &ldquo;Need help?&rdquo; button in the guide.
          </p>
        </div>

        {/* FAQ Categories */}
        <div className="space-y-8">
          {faqs.map((category) => (
            <div key={category.category}>
              <h2 className="mb-4 font-heading text-xl font-bold text-[var(--c-text)]">{category.category}</h2>
              <div className="space-y-2">
                {category.questions.map((item, qi) => {
                  const key = `${category.category}-${qi}`;
                  const isOpen = openItems[key];
                  return (
                    <div
                      key={key}
                      data-testid={`faq-item-${key}`}
                      className="rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] shadow-[3px_3px_0px_var(--c-shadow)] transition-all"
                    >
                      <button
                        onClick={() => toggle(key)}
                        className="flex w-full items-center justify-between gap-3 p-5 text-left"
                      >
                        <span className="font-heading text-sm font-semibold text-[var(--c-text)] sm:text-base">
                          {item.q}
                        </span>
                        <ChevronDown
                          className={`h-5 w-5 flex-shrink-0 text-[var(--c-muted)] transition-transform ${
                            isOpen ? "rotate-180" : ""
                          }`}
                        />
                      </button>
                      {isOpen && (
                        <div className="border-t-2 border-[var(--c-border-light)] px-5 pb-5 pt-3">
                          <p className="text-sm leading-relaxed text-[var(--c-muted)]">{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-10 rounded-xl border-2 border-dashed border-[var(--c-border-medium)] bg-[var(--c-bg)] p-6 text-center">
          <p className="font-heading text-base font-bold text-[var(--c-text)]">Still have questions?</p>
          <p className="mt-1 text-sm text-[var(--c-muted)]">Our team is here to help you through the process.</p>
          <button
            data-testid="faq-contact-cta"
            onClick={() => navigate("/services")}
            className="mt-4 inline-flex items-center gap-2 rounded-full border-2 border-[var(--c-border)] bg-[#1E3A8A] px-5 py-2.5 text-sm font-bold text-white shadow-[3px_3px_0px_var(--c-shadow)] transition-all hover:-translate-y-0.5"
          >
            Get Expert Help
          </button>
        </div>
      </div>
    </div>
  );
}
